import { render } from "./product-delete.vue?vue&type=template&id=23078fbc"
import script from "./product-delete.vue?vue&type=script&lang=js"
export * from "./product-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__